// Libraries
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params }   from '@angular/router';
import { BookingComponent } from '../BookingComponent';
import { CalendarModule } from 'primeng/primeng';
import * as _ from 'lodash';
import * as moment from 'moment';

// Services
import { BookingHolidayService } from '../../../services';
import { ClassService, AttendanceService } from '../../../services';
import { SessionStorageService, FileService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';

//Models
import { ClassChild, BookingItem, AttendancesFilter } from '../../../models';

@Component({
    selector: 'attendance',
    template: require('./AttendanceComponent.html'),
    styles: [ require('./AttendanceComponent.sass') ]
})

export class AttendanceComponent extends BookingComponent implements OnInit {
    private holidayChildren: any = [];
    private selectedChildId: number;
    private selectedChild: ClassChild;
    private attendanceFilter: AttendancesFilter = new AttendancesFilter;
    private attendanceList: any = [];
    private selectedClasses: any;
    private tabs : any[];
    // Current selected date
    private currentStudent: any = [];
    private currentAisId: string = '';
    private currentDate: Date = new Date();
    private currentStudentStartDate: any;
    private currentStudentEndDate: any;
    private startOfWeek: string
    private endOfWeek: string
    // On attendance slot
    private startDate: string
    private endDate: string
    private bookingDetail: any;
    private minDate: any;
    private maxDate: any
    constructor(
        protected router: Router,
        protected route: ActivatedRoute,
        protected services: BookingHolidayService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService,
        protected catalogService: CatalogService,
        protected attendanceService: AttendanceService
    ){
        super(router, services, sessionStorageService, catalogService);

        // Init days of week tabs
        this.tabs = [
            {id: 'Mon', name: 'Monday'},
            {id: 'Tue', name: 'Tuesday'},
            {id: 'Wed', name: 'Wednesday'},
            {id: 'Thu', name: 'Thursday'},
            {id: 'Fri', name: 'Friday'}
        ];

        // Init attendance array with keys are days of week
        this.attendanceList = {
            Mon: [],
            Tue: [],
            Wed: [],
            Thu: [],
            Fri: []
        }
    }

    ngOnInit() {
        // Get student list
        this.holidayChildren = this.getHolidayChildren();
        // Get 1st child
        if(this.holidayChildren){
            this.currentAisId = this.holidayChildren.holStudents[0].code;
        }
        // Get attendance list of current date
        this.getWeekDates(this.currentDate);
    }

    // Get attendance list
    getAttendance() {
        // Init attendance array with keys are days of week
        this.attendanceList = {
            Mon: [],
            Tue: [],
            Wed: [],
            Thu: [],
            Fri: []
        }
        // Get current selected child id
        this.attendanceFilter.studentCode = this.currentAisId;
        // Get attendance info with range
        this.attendanceFilter.fromDate = this.startOfWeek;
        this.attendanceFilter.toDate = this.endOfWeek;
        // Set high max per page for getting all records
        this.attendanceFilter.max_per_page = 100;
        // Retrieve attendance info
        this.attendanceService.getAttendancesList(this.attendanceFilter).subscribe(
            result => {
                if(result.data.length){
                    this.currentStudent = result.data[0];
                    this.getBookingDetail();
                    this.currentStudentStartDate = result.data[0].weeks[0].start_date
                    this.currentStudentEndDate =  result.data[0].weeks[result.data[0].weeks.length -1].end_date;
                    // Filter attendance info with day of weeks slot
                    _.forEach(result.data[0].attendances, (val, key) => {
                        let day = moment(val.date).days();
                        switch(+day){
                            case 1:
                                this.attendanceList['Mon'].push(val)
                                break;
                            case 2:
                                this.attendanceList['Tue'].push(val)
                                break;
                            case 3:
                                this.attendanceList['Wed'].push(val)
                                break;
                            case 4:
                                this.attendanceList['Thu'].push(val)
                                break;
                            case 5:
                                this.attendanceList['Fri'].push(val)
                                break;
                        }
                    })
                    // Get start and end date of class
                    this.getStartEndDate(result.data[0].weeks);
                }
            },
            error => {

            }
        )
    }
    // Retrieve start/end date base on week
    getStartEndDate(weeks: any){
        let start: string;
        let end: string;

        // Init start/end date
        start = weeks[0].start_date;
        end = weeks[0].end_date;

        _.forEach(weeks, (pVal, pKey) => {
            if(pKey){
                let week : any = _.find(weeks, {'id': pVal});
                if(week){
                    // Compare start date
                    if(moment(week.start_date).isBefore(start)){
                        start = week.start_date;
                    }
                    // Compare end date
                    if(moment(week.end_date).isAfter(end)){
                        end = week.end_date;
                    }
                }
            }
        })

        this.startDate = moment(start).format('MMM d YYYY');
        this.endDate = moment(end).format('MMM d YYYY');
    }

    //Get booking detail
    getBookingDetail() {
        this.services.getBookingById(this.currentStudent.aisid)
            .subscribe(
                (result: any) => {
                    this.bookingDetail = result.data[0]
                    // Get the min and max date
                    let startDate : any = [];
                    let endDate : any = [];
                    let Weeks = _.forEach(this.bookingDetail.hol_weeks, function(week, key) {
                        startDate.push(new Date(week.start_date))
                        endDate.push(new Date(week.end_date))
                    });
                    //Get the min date of week array
                    this.minDate = new Date(Math.min.apply(null,startDate));
                    //Get the max date of week array
                    this.maxDate = new Date(Math.max.apply(null,endDate));
                },
                (error: any) => {

                }
            )
    }
    // Get start/end of week with specific date input
    // @date: string or Date
    // based on momentjs Sunday is 0 and Saturday is 6, our Week days are counted from 1 to 5
    getWeekDates(date: any) {
        // Detect input date current day of week
        let currentDOW = moment(date).day();
        // Detect how many day to start of week
        let toStartWeek = 1 - currentDOW;
        // Detect how many day to end of week
        let toEndWeek = 5 - currentDOW;
        // Retrieve start/end date of week
        this.startOfWeek = moment(date).add(toStartWeek, 'days').format('YYYY-MM-DD');
        this.endOfWeek = moment(date).add(toEndWeek, 'days').format('YYYY-MM-DD');
        // Retrieve attendance list
        this.getAttendance();
    }

    // Set current date to today
    setToday() {
        this.currentDate = new Date;
        // New data
        this.getWeekDates(this.currentDate);
    }

    // Get next week data
    nextWeek(){
        // Add 3 days from end of current week (Friday) to Monday of next week
        let date = moment(this.endOfWeek, 'YYYY-MM-DD').add(3, 'days');
        this.currentDate = new Date(date);
        // New data
        this.getWeekDates(date);
    }

    // Get previous week data
    prevWeek(){
        // Substract 3 days from start of current week (Monday) to Friday of previous week
        let date = moment(this.startOfWeek, 'YYYY-MM-DD').add(-3, 'days');
        this.currentDate = new Date(date);
        // New data
        this.getWeekDates(date);
    }

    // Change child function
    changeChild(e: any) {
        // Refresh attendance data
        this.getAttendance();
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/attendance/AttendanceComponent.ts